export function StatCard({ icon: Icon, label, value, color = 'text-[#D4AF37]', testId }) {
  return (
    <div className="card-surface p-4" data-testid={testId}>
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`h-4 w-4 ${color}`} />
        <span className="text-sm text-stone-500">{label}</span>
      </div>
      <p className="text-2xl font-semibold text-[#1A1A1A]">{value}</p>
    </div>
  );
}
